import { IModalsConfig } from '../../modals.config.interface';

export const FINAL_DECISION_MILESTONE_MODAL_CONFIG: IModalsConfig = {
  buttons: {
    confirm: { text: 'Confirm', disableButtonRipple: true },
    cancel: { text: 'Cancel', disableButtonRipple: true },
    acknowledged: { text: 'Confirm', disableButtonRipple: true },
  },
};
